import { useEffect } from 'react';
import { Fab, Zoom, useTheme } from '@mui/material';
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import CloseIcon from '@mui/icons-material/Close';

export const ChatbotButton = ({
  setIsChatOpen,
  isChatOpen,
  setShowButton,
  showButton
}: {
  setIsChatOpen: (isOpen: boolean) => void;
  isChatOpen: boolean;
  setShowButton: (isOpen: boolean) => void;
  showButton: boolean;
}) => {
  const theme = useTheme();

  useEffect(() => {
    setTimeout(() => {
      setShowButton(true);
    }, 3000);
  }, [setShowButton]);

  const hideChatbot = import.meta.env.VITE_CHATBOT_ENABLED.toLowerCase() !== 'true';
  if (hideChatbot) {
    return null;
  }

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  return (
    <Zoom
      in={showButton}
      timeout={transitionDuration}
      style={{
        transitionDelay: `${showButton ? transitionDuration.exit : 0}ms`
      }}
      unmountOnExit
    >
      <Fab
        variant="extended"
        size="large"
        aria-label={'Open chat bot'}
        color={'secondary'}
        sx={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          textTransform: 'initial'
        }}
        onClick={() => setIsChatOpen(!isChatOpen)}
      >
        {!isChatOpen && <MarkUnreadChatAltIcon sx={{ mr: 1 }} />}
        {isChatOpen && <CloseIcon />}
        Try our CPD Virtual Assistant
      </Fab>
    </Zoom>
  );
};

export default ChatbotButton;
